exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-select-container {\n  padding: 0 0.8rem;\n}\n\n.common-label-text {\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-bottom: 0.2rem;\n  margin-top: 1.2rem;\n  color: #202020;\n}\n\n.common-select-text {\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.8rem;\n  color: #202020;\n  font-weight: 500;\n}\n.td--reorder {\n  width: 200px;\n}\n", ""]);

// exports
